import React, { useEffect } from "react";

const Modal = ({ children, open, closeFn, size }) => {
  useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }, [open]);

  useEffect(() => {
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);

  if (!open) return null;
  let sizeClassname = "lg:w-1/2";
  if(size === 'large') {
    sizeClassname = "lg:w-3/4";
  }
  if(size === 'medium') {
    sizeClassname = "lg:w-2/5";
  }
  if(size === 'small') {
    sizeClassname = "";
  }

  return (
    <div className="fixed z-[200] inset-0 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
      <div className="flex items-end justify-center min-h-[calc(var(--vh,_1vh)_*_100)] pb-4 pt-[5rem] px-4 text-center sm:block sm:p-0">
        <div role="button" tabIndex={-1} onKeyDown={closeFn} onClick={closeFn} className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true" />
        <span className="hidden sm:inline-block sm:align-middle sm:h-[calc(var(--vh,_1vh)_*_100)]" aria-hidden="true">&#8203;</span>
        <div className={`w-full md:w-96 ${sizeClassname} relative inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left shadow-xl transform transition-all sm:my-8 sm:align-middle sm:p-6 overflow-auto max-h-[calc(100vh_-_7rem)]`}>
          {children}
        </div>
      </div>
    </div>
  )
}

export default Modal;